import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import content from 'assets/content/product.content.json';

import InsideBoxItems from 'assets/images/general/ic-inside-the-box-items.png';

import './InsideBox.scss';
import GalaxyS25EdgeIcyblue from 'assets/images/products/whats-in-the-box/galaxy-s25-edge-icyblue.jpg';
import GalaxyS25EdgeJetblack from 'assets/images/products/whats-in-the-box/galaxy-s25-edge-jetblack.jpg';

export default function InsideBox({
    product,
    selectedColor
}) {
    const [boxItems, setBoxItems] = useState(['Smartphone', 'Data Cable', 'Ejection Pin']);
    const additionalItem = product?.name === 'Galaxy S24 Ultra'
        ? '* Galaxy S24 Ultra does not include travel adapter'
        : null;

    const updateBoxItems = () => {
        const insideBoxMeta = product?.attributes?.inside_box?.values?.find(value => value.key === 'box')?.meta;

        if (!Array.isArray(insideBoxMeta)) return;
        const itemList = insideBoxMeta?.find(meta => meta?.item_list && meta?.item_list?.length > 0)?.item_list;

        if (itemList && itemList?.length > 0) {
            setBoxItems(itemList);
        }
    };

    const getSelectedColorInsideBoxItem = () => {
        if (product?.slug === 'samsung-galaxy-s25-edge') {
            return selectedColor?.text === 'Titanium Icyblue' ? GalaxyS25EdgeIcyblue : GalaxyS25EdgeJetblack;
        }

        const insideBox = product?.attributes?.inside_box?.values?.find(value => value.key === 'box');
        const meta = insideBox?.meta;
        const selectedColorId = selectedColor?.value;

        // eslint-disable-next-line camelcase
        const selectedMeta = Array.isArray(meta) ? meta.find(({ color_id }) => color_id === selectedColorId) : null;

        return selectedMeta?.icon_url || InsideBoxItems;
    };

    useEffect(() => {
        updateBoxItems();
    });

    return (
        <div className='insideBox'>
            <p className='insideBox__title' dangerouslySetInnerHTML={{ __html: content?.CONTENT.WHAT_IS_INSIDE_BOX }} />
            <img className='insideBox__img' src={getSelectedColorInsideBoxItem()} alt='Inside box items' />
            <div className='insideBox__content'>
                {_.map(boxItems, (item, i) => <p key={i} className='insideBox__list'>{`${i + 1}. ${item}`}</p>)}
                {additionalItem && <p className='insideBox__list'>{additionalItem}</p>}
            </div>
        </div>
    );
}

InsideBox.propTypes = {
    product: PropTypes.object,
    selectedColor: PropTypes.object
};
